import '@polymer/iron-media-query/iron-media-query';

import { PolymerElement, html } from '@polymer/polymer/polymer-element';

import {
  MEDIA_QUERY_LARGE,
  MEDIA_QUERY_MEDIUM,
  MEDIA_QUERY_SMALL,
} from './neb-layout-media-store';

export class NebLayoutMedia extends PolymerElement {
  static get template() {
    return html`
      <iron-media-query
        query="[[__MEDIA_QUERY_SMALL]]"
        query-matches="{{layoutSmall}}"
      ></iron-media-query>
      <iron-media-query
        query="[[__MEDIA_QUERY_MEDIUM]]"
        query-matches="{{layoutMedium}}"
        full
      ></iron-media-query>
      <iron-media-query
        query="[[__MEDIA_QUERY_LARGE]]"
        query-matches="{{layoutLarge}}"
      ></iron-media-query>
    `;
  }

  static get properties() {
    return {
      layoutSmall: {
        type: Boolean,
        notify: true,
        reflectToAttribute: true,
      },
      layoutMedium: {
        type: Boolean,
        notify: true,
        reflectToAttribute: true,
      },
      layoutLarge: {
        type: Boolean,
        notify: true,
        reflectToAttribute: true,
      },
      __MEDIA_QUERY_SMALL: {
        type: Boolean,
        notify: true,
      },
      __MEDIA_QUERY_MEDIUM: {
        type: Boolean,
        notify: true,
      },
      __MEDIA_QUERY_LARGE: {
        type: Boolean,
        notify: true,
      },
    };
  }

  constructor() {
    super();
    this.__MEDIA_QUERY_SMALL = MEDIA_QUERY_SMALL;
    this.__MEDIA_QUERY_MEDIUM = MEDIA_QUERY_MEDIUM;
    this.__MEDIA_QUERY_LARGE = MEDIA_QUERY_LARGE;
  }
}
customElements.define('neb-layout-media', NebLayoutMedia);
